<template>
  <div class="relative flex items-center justify-center px-4 h-dvh lg:max-w-none lg:px-0">
    <div
      class="relative hidden h-full flex-1 flex-col bg-muted p-10 text-white lg:flex dark:border-r"
    >
      <div class="absolute inset-0 login-background" />
      <div class="relative z-20 flex items-center text-lg font-medium">
        <!--         {{ t('DjPageAuth.title') }}
 -->
      </div>
      <div class="relative z-20 flex items-center text-lg font-medium">
        <!--         {{ t('DjPageAuth.subTitle') }}
 -->
      </div>
      <div class="relative z-20 mt-auto">
        <blockquote class="space-y-2">
<!--           <p class="text-lg">&ldquo;{{ t('DjPageAuth.description') }}&rdquo;</p>
 -->          <footer class="text-sm" />
        </blockquote>
      </div>
    </div>
    <div class="mx-auto flex-1 lg:p-8">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
  defineOptions({
    name: 'AuthLayout',
  });
  const { t } = useI18n();
</script>
<style lang="scss" scoped>
  .login-background {
        /* grid-column-gap: 1rem; */
    /* grid-row-gap: 1rem; */
    text-align: center;
    /* background-color: #000d1a; */
    background-image: url('/fond4.jpg');
    /* background-position: 50% -3px, 50% -3px; */
    background-repeat: no-repeat, no-repeat;
    background-size: 155%, 100%;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    display: flex
;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.2509803922);
  }
</style>
